/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  WorkshopAttendanceBulkCreate,
  WorkshopAttendanceBulkResult,
  WorkshopAttendanceBulkStatus,
  WorkshopAttendanceCreate,
  WorkshopAttendanceRead,
  WorkshopAttendanceUpdate,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    WorkshopAttendanceBulkCreateFromJSON,
    WorkshopAttendanceBulkCreateToJSON,
    WorkshopAttendanceBulkResultFromJSON,
    WorkshopAttendanceBulkResultToJSON,
    WorkshopAttendanceBulkStatusFromJSON,
    WorkshopAttendanceBulkStatusToJSON,
    WorkshopAttendanceCreateFromJSON,
    WorkshopAttendanceCreateToJSON,
    WorkshopAttendanceReadFromJSON,
    WorkshopAttendanceReadToJSON,
    WorkshopAttendanceUpdateFromJSON,
    WorkshopAttendanceUpdateToJSON,
} from '../models/index';

export interface AddAttendanceBulkRequest {
    workshopId: string;
    workshopAttendanceBulkCreate: WorkshopAttendanceBulkCreate;
    xOrganizationID?: string | null;
}

export interface AddAttendanceFromClassRequest {
    workshopId: string;
    classId: string;
    xOrganizationID?: string | null;
}

export interface BulkUpdateAttendanceStatusRequest {
    workshopId: string;
    workshopAttendanceBulkStatus: WorkshopAttendanceBulkStatus;
    xOrganizationID?: string | null;
}

export interface CheckInUserRequest {
    workshopId: string;
    userId: string;
    xOrganizationID?: string | null;
}

export interface DeleteAttendanceRequest {
    attendanceId: string;
    xOrganizationID?: string | null;
}

export interface GetAttendanceRequest {
    attendanceId: string;
    xOrganizationID?: string | null;
}

export interface ListAttendanceRequest {
    workshopId: string;
    xOrganizationID?: string | null;
}

export interface RegisterAttendanceRequest {
    workshopId: string;
    workshopAttendanceCreate: WorkshopAttendanceCreate;
    xOrganizationID?: string | null;
}

export interface UpdateAttendanceRequest {
    attendanceId: string;
    workshopAttendanceUpdate: WorkshopAttendanceUpdate;
    xOrganizationID?: string | null;
}

/**
 * 
 */
export class WorkshopAttendanceApi extends runtime.BaseAPI {

    /**
     * Add several users as participants in one call. Organization admin or mentor only.  Existing participants, non-members of the organization and deactivated accounts are skipped and counted; a repeated id counts once.
     * Add Attendance Bulk
     */
    async addAttendanceBulkRaw(requestParameters: AddAttendanceBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkshopAttendanceBulkResult>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling addAttendanceBulk().'
            );
        }

        if (requestParameters['workshopAttendanceBulkCreate'] == null) {
            throw new runtime.RequiredError(
                'workshopAttendanceBulkCreate',
                'Required parameter "workshopAttendanceBulkCreate" was null or undefined when calling addAttendanceBulk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}/attendance/bulk`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkshopAttendanceBulkCreateToJSON(requestParameters['workshopAttendanceBulkCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkshopAttendanceBulkResultFromJSON(jsonValue));
    }

    /**
     * Add several users as participants in one call. Organization admin or mentor only.  Existing participants, non-members of the organization and deactivated accounts are skipped and counted; a repeated id counts once.
     * Add Attendance Bulk
     */
    async addAttendanceBulk(requestParameters: AddAttendanceBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkshopAttendanceBulkResult> {
        const response = await this.addAttendanceBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add all members of a class as participants. Organization admin or mentor only.  Existing participants and non-members of the organization are skipped and counted.
     * Add Attendance From Class
     */
    async addAttendanceFromClassRaw(requestParameters: AddAttendanceFromClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkshopAttendanceBulkResult>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling addAttendanceFromClass().'
            );
        }

        if (requestParameters['classId'] == null) {
            throw new runtime.RequiredError(
                'classId',
                'Required parameter "classId" was null or undefined when calling addAttendanceFromClass().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}/attendance/from-class/{class_id}`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))).replace(`{${"class_id"}}`, encodeURIComponent(String(requestParameters['classId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkshopAttendanceBulkResultFromJSON(jsonValue));
    }

    /**
     * Add all members of a class as participants. Organization admin or mentor only.  Existing participants and non-members of the organization are skipped and counted.
     * Add Attendance From Class
     */
    async addAttendanceFromClass(requestParameters: AddAttendanceFromClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkshopAttendanceBulkResult> {
        const response = await this.addAttendanceFromClassRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set one status on several participants of a workshop. Organization admin or mentor only.  Every id must be a participant of this workshop, otherwise nothing changes (404).
     * Bulk Update Attendance Status
     */
    async bulkUpdateAttendanceStatusRaw(requestParameters: BulkUpdateAttendanceStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkshopAttendanceRead>>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling bulkUpdateAttendanceStatus().'
            );
        }

        if (requestParameters['workshopAttendanceBulkStatus'] == null) {
            throw new runtime.RequiredError(
                'workshopAttendanceBulkStatus',
                'Required parameter "workshopAttendanceBulkStatus" was null or undefined when calling bulkUpdateAttendanceStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}/attendance/status`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: WorkshopAttendanceBulkStatusToJSON(requestParameters['workshopAttendanceBulkStatus']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkshopAttendanceReadFromJSON));
    }

    /**
     * Set one status on several participants of a workshop. Organization admin or mentor only.  Every id must be a participant of this workshop, otherwise nothing changes (404).
     * Bulk Update Attendance Status
     */
    async bulkUpdateAttendanceStatus(requestParameters: BulkUpdateAttendanceStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkshopAttendanceRead>> {
        const response = await this.bulkUpdateAttendanceStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check in a participant. Admin or mentor any time; a participant only themselves, in the window.
     * Check In User
     */
    async checkInUserRaw(requestParameters: CheckInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkshopAttendanceRead>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling checkInUser().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling checkInUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}/check-in/{user_id}`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkshopAttendanceReadFromJSON(jsonValue));
    }

    /**
     * Check in a participant. Admin or mentor any time; a participant only themselves, in the window.
     * Check In User
     */
    async checkInUser(requestParameters: CheckInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkshopAttendanceRead> {
        const response = await this.checkInUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a participant. Organization admin or mentor only.
     * Delete Attendance
     */
    async deleteAttendanceRaw(requestParameters: DeleteAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['attendanceId'] == null) {
            throw new runtime.RequiredError(
                'attendanceId',
                'Required parameter "attendanceId" was null or undefined when calling deleteAttendance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/attendance/{attendance_id}`.replace(`{${"attendance_id"}}`, encodeURIComponent(String(requestParameters['attendanceId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a participant. Organization admin or mentor only.
     * Delete Attendance
     */
    async deleteAttendance(requestParameters: DeleteAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAttendanceRaw(requestParameters, initOverrides);
    }

    /**
     * Get a single attendance record. Organization admin, mentor or participant.
     * Get Attendance
     */
    async getAttendanceRaw(requestParameters: GetAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkshopAttendanceRead>> {
        if (requestParameters['attendanceId'] == null) {
            throw new runtime.RequiredError(
                'attendanceId',
                'Required parameter "attendanceId" was null or undefined when calling getAttendance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/attendance/{attendance_id}`.replace(`{${"attendance_id"}}`, encodeURIComponent(String(requestParameters['attendanceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkshopAttendanceReadFromJSON(jsonValue));
    }

    /**
     * Get a single attendance record. Organization admin, mentor or participant.
     * Get Attendance
     */
    async getAttendance(requestParameters: GetAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkshopAttendanceRead> {
        const response = await this.getAttendanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the participants of a workshop. Organization admin, mentor or participant.
     * List Attendance
     */
    async listAttendanceRaw(requestParameters: ListAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkshopAttendanceRead>>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling listAttendance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}/attendance`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkshopAttendanceReadFromJSON));
    }

    /**
     * List the participants of a workshop. Organization admin, mentor or participant.
     * List Attendance
     */
    async listAttendance(requestParameters: ListAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkshopAttendanceRead>> {
        const response = await this.listAttendanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add one organization member as a participant. Organization admin or mentor only.
     * Register Attendance
     */
    async registerAttendanceRaw(requestParameters: RegisterAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkshopAttendanceRead>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling registerAttendance().'
            );
        }

        if (requestParameters['workshopAttendanceCreate'] == null) {
            throw new runtime.RequiredError(
                'workshopAttendanceCreate',
                'Required parameter "workshopAttendanceCreate" was null or undefined when calling registerAttendance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}/attendance`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkshopAttendanceCreateToJSON(requestParameters['workshopAttendanceCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkshopAttendanceReadFromJSON(jsonValue));
    }

    /**
     * Add one organization member as a participant. Organization admin or mentor only.
     * Register Attendance
     */
    async registerAttendance(requestParameters: RegisterAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkshopAttendanceRead> {
        const response = await this.registerAttendanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update attendance status and/or notes. Organization admin or mentor only.
     * Update Attendance
     */
    async updateAttendanceRaw(requestParameters: UpdateAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkshopAttendanceRead>> {
        if (requestParameters['attendanceId'] == null) {
            throw new runtime.RequiredError(
                'attendanceId',
                'Required parameter "attendanceId" was null or undefined when calling updateAttendance().'
            );
        }

        if (requestParameters['workshopAttendanceUpdate'] == null) {
            throw new runtime.RequiredError(
                'workshopAttendanceUpdate',
                'Required parameter "workshopAttendanceUpdate" was null or undefined when calling updateAttendance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/attendance/{attendance_id}`.replace(`{${"attendance_id"}}`, encodeURIComponent(String(requestParameters['attendanceId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: WorkshopAttendanceUpdateToJSON(requestParameters['workshopAttendanceUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkshopAttendanceReadFromJSON(jsonValue));
    }

    /**
     * Update attendance status and/or notes. Organization admin or mentor only.
     * Update Attendance
     */
    async updateAttendance(requestParameters: UpdateAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkshopAttendanceRead> {
        const response = await this.updateAttendanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
